export default __webpack_public_path__ + "static/media/HandheldBandSawImg.a3a1896d.jpg";